import styled from 'styled-components';

export const Wrapper = styled.form`
  display: grid;
  width: 100%;
  gap: 24px;
  grid-template-rows: min-content 1fr;

  > div:first-child {
    width: 464px;
    min-height: 188px;
  }
`;

export const DividerStyled = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.color.grey200};
`;
